import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { PersonSearchService,Similarobject } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { AiModalScComponent, SCPassData } from 'src/app/ai-modal-sc/ai-modal-sc.component';
import { from } from 'rxjs';
import { SimilarCandidateService } from 'src/app/_services/similar-candidate.service';

import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { GlobalService } from 'src/app/_services/global.service';
@Component({
    selector: 'app-similar-candidates',
    templateUrl: './similar-candidates.component.html',
    styleUrls: ['./similar-candidates.component.scss'],
    standalone: false
})
export class SimilarCandidatesComponent implements OnInit {
  @ViewChild('uploadlinkedin') uploadlinkedin: TemplateRef<any>;
  @ViewChild('uploadResume') uploadResume: TemplateRef<any>;
  @ViewChild('showLinkedinGuide') showLinkedinGuide: TemplateRef<any>;



  linkedinurl: string = ''
  uploadedFilename: any
  similarobj: Similarobject;
  linkedinerrormsg: string = ''
  parseresumeresp: any
  disableSimilarBtn: boolean = true;

  historySubject : Subject<any> = new Subject<any>();
  savedHistorySubject : Subject<any> = new Subject<any>();
  showHistoryViewAll: any;
  showSavedHistoryViewAll: any;

  /**Error message for unsupported file types on resume upload */
  resumeUploadErrorMessage: string = '';
  jdDataLoading:boolean=false
  uploadedFile = null;
  isUploadedFileCorrect = false;
  incorrectFileFormat = false;
  specialCharaterError = false;
  fileSizeLimitExceeded = false;

    constructor(public modalService: NgbModal, private personsearchservice: PersonSearchService, private router: Router, private companyinsightsservice: CompanyInsightsService,  private localStorageService: LocalStorageService,
    private similarCandidateService: SimilarCandidateService) { }

  ngOnInit() {
  }

  uploadonLinkedin() {
    const confirmRef = this.modalService.open(this.uploadlinkedin, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  checkHistory(event, saveMode: boolean = false){
    if(event === 'REFRESH') {
      this.savedHistorySubject.next(event);
    } else {
      this[saveMode ? 'showSavedHistoryViewAll' : 'showHistoryViewAll'] = event;
    }
  }

  viewAllHistory(saveMode: boolean = false){
    this[saveMode ? 'savedHistorySubject' : 'historySubject'].next(undefined as any);
  }
onLinkedinUrlChange(value: string) {
    // console.log('linkedinurl changed:', this.linkedinurl);
    // this.username is already updated due to ngModel binding
    this.linkedinerrormsg = '';
  }
  getdetailsFromLinkedin() {
    this.linkedinerrormsg = '';
    const hasEuPersonSearchAccess = this.localStorageService.getItem('hasEUPersonSearchAccess')
    if(!this.linkedinurl) return;
    this.jdDataLoading = true
    this.personsearchservice.getdetailsfromlinkedin(this.linkedinurl).subscribe((res:any)=>{
      if(res.status == "success") {
        if(res.data) {
          this.jdDataLoading = false
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const degrees = _.uniq(_.flatten(_.map(res.data.education, 'degrees')));
          const fieldOfStudy = _.uniq(
            _.flatten(
              _.map(res.data.education, "majors").concat(
                _.map(res.data.education, "minors")
              )
            )
          );

          const locations = []
          const locParts = [];

          res.data.location_locality && locParts.push(res.data.location_locality);
          res.data.location_region && locParts.push(res.data.location_region);
          res.data.location_country && locParts.push(res.data.location_country);

          if (locParts.length) {
            locations.push(locParts.join(', '));
          }

          const totalTenure = res.data.totaltenure || 0;
          let fromYrsOfExperience = 0;
            let toYrsOfExperinece = 0;

            if (!isNaN(totalTenure) && totalTenure >= 0) {
              if (totalTenure > 2) {
                fromYrsOfExperience = Math.floor(totalTenure - 2);
                toYrsOfExperinece = Math.ceil(totalTenure + 2);
              } else {
                fromYrsOfExperience = 0;
                toYrsOfExperinece = Math.ceil(totalTenure + 2);
              }
            }

          this.similarobj = {
            jobtitle: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
            jobcompanyname: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
            jobindustryname: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
            pastindustries: _.pluck(pastindustries, 'industry'),
            schools: schools && schools.length ? _.pluck(schools, 'name')?.filter(school => school != null).map(el => ({key: el, isMandatory: false}) ) : [],
            currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
            degrees: degrees && degrees.length ? degrees?.filter(d => d != null)?.map(d => ({ key: d, isMandatory: false })) : [],
            skills: res.data.skills ? res.data.skills?.filter(skill => skill != null)?.map(s => ({ key: s, isMandatory: false })) : [],
            fieldOfStudy: fieldOfStudy && fieldOfStudy.length ? fieldOfStudy?.filter(f => f != null)?.map(f => ({ key: f, isMandatory: false })) : [],
            elasticid: res.data.id,
            companysize: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
            fullname: res.data.full_name,
            linkedinurl: this.linkedinurl,
            isUploadedFromResume: false,
            locationregion: res.data.location_region,
            locationcontinent: res.data.location_continent,
            totaltenure: totalTenure,
            fromYrsOfExperience,
            toYrsOfExperinece

          }

          if(hasEuPersonSearchAccess == 1 && res.data.location_continent == 'europe') {

          }

          if((hasEuPersonSearchAccess == 1 && res.data.location_continent == 'europe') || (res.data.location_continent != 'europe' && res.data.location_continent != 'antarctica' && res.data.location_country != 'philippines')) {
            this.openSimilarCandidateFilters('similar-candidate-from-linkedinurl');
          } else {
            this.linkedinerrormsg = `Apologies, profiles from the "${res.data.location_continent}" region are not displayed due to GDPR constraints.`
          }
        } else if(res.message == 'Person not found') {
          this.linkedinerrormsg = 'Sorry, for some reason we were unable to find this LinkedIn profile.'
          this.jdDataLoading = false
          this.modalService.open(this.showLinkedinGuide, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
        }


      }
    })

  }

  getobj(): Similarobject {
    return this.similarobj;
  }

  dismiss() {
    this.uploadedFilename = null;
    this.disableSimilarBtn = true;
    this.linkedinurl = '';

    this.modalService.dismissAll()
  }

  uploadFromResume() {
    const confirmRef = this.modalService.open(this.uploadResume, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  uploadFile(event) {
    this.resumeUploadErrorMessage = '';
    let file: File = event.target.files[0]
    this.uploadedFilename = file.name
    this.uploadedFile = GlobalService.validateAndSanitizeFile(file);
    this.jdDataLoading = true;
    this.validateInputFile()
    if (this.uploadedFile && !this.specialCharaterError && !this.incorrectFileFormat && !this.fileSizeLimitExceeded){
      this.personsearchservice.parseresume(this.uploadedFile).subscribe((res:any)=>{
        if(res.status == "success") {
        this.jdDataLoading = false;
        this.parseresumeresp = res.message
        const locations = [];
        const address = res?.message?.address?.[0];
        if (address) {
          const loc: string[] = [];

          if (address.City) loc.push(address.City);
          if (address.State) loc.push(address.State);
          if (address.Country) loc.push(address.Country);

          // check for all three fields are present or else use exactLocationMatch
          if (address.exactLocationMatch) {
            locations.push(address.exactLocationMatch);
          }
        }
        let skills = res.message.skills.filter(x=>x.type != 'SoftSkill')
        const employer = _.pluck(res.message.segregateedexperience, 'Employer')
        const pastindustries = _.pluck(employer, 'EmployerName')
        const recommendpayload ={
          startindex: 0,
          resultsize: 10,
          searchviaboolean: true,
          booleanquery: "*",
          industries: [],
          locations: [],
          companysizes: [],
           companybuckettypes: [
              "Fortun500"
           ],
            companynames: pastindustries
        }

        this.companyinsightsservice.getRecommendedcompanies(recommendpayload).subscribe((res:any)=>{
          if(res.status == 'success') {
            const companysizes = _.uniq(_.pluck(res.data.results, 'size'))
            const industries = _.uniq(_.pluck(res.data.results, 'industry'))
            skills = _.uniq(_.pluck(skills, 'skill'));

            const totalTenure = this.parseresumeresp.candidatebasicinfo.totalexperience || 0;
            let fromYrsOfExperience = 0;
            let toYrsOfExperinece = 0;

            if (!isNaN(totalTenure) && totalTenure >= 0) {
              if (totalTenure > 2) {
                fromYrsOfExperience = Math.floor(totalTenure - 2);
                toYrsOfExperinece = Math.ceil(totalTenure + 2);
              } else {
                fromYrsOfExperience = 0;
                toYrsOfExperinece = Math.ceil(totalTenure + 2);
              }
            }

            const degrees = _.pluck(this.parseresumeresp.education, 'degree');
            const schools = _.pluck(this.parseresumeresp.education, 'schoolname')

            const first = this.parseresumeresp.candidatebasicinfo.firstname;
            const last = this.parseresumeresp.candidatebasicinfo.lastname;

            this.similarobj = {
              jobtitle: [{ key: this.parseresumeresp?.candidatebasicinfo?.jobtitle || this.parseresumeresp?.experience?.[0]?.jobtitle, isMandatory: true }].filter(item => item.key),
              jobcompanyname: [{ key: this.parseresumeresp?.candidatebasicinfo?.currentcompany || this.parseresumeresp?.experience?.[0]?.company, isMandatory: false }].filter(item => item.key),
              jobindustryname: industries.map(i => ({ key: i, isMandatory: false })),
              pastindustries: industries,
              schools: schools && schools.length ? schools?.filter(school => school != null)?.map(el => ({key: el, isMandatory: false})) : [],
              currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
              skills: skills?.length > 0 ? skills?.filter(skill => skill != null)?.map(skill => ({ key: skill, isMandatory: false })) : [],
              degrees: degrees?.length > 0 ? degrees?.filter(d => d != null)?.map(d => ({ key: d, isMandatory: false })) : [],
              elasticid: null,
              companysize: companysizes.map(cs => ({ key: cs, isMandatory: false })),
              fullname: (first || last) ? `${first || ''} ${last || ''}`.trim() : null,
              firstname: first || null,
              lastname: last  || null,
              linkedinurl: this.linkedinurl,
              isUploadedFromResume: true,
              locationregion: null,
              locationcontinent: this.parseresumeresp?.address?.[0]?.continent? this.parseresumeresp?.address?.[0]?.continent.toLowerCase() : null,
              totaltenure: totalTenure,
              fromYrsOfExperience,
              toYrsOfExperinece
            }
            this.disableSimilarBtn = false;
              this.jdDataLoading = false;
            }
          })


        }
      }, (err)=>{
        if(err.status == 400 && err.error.error == 'invalid_file_type') {
          this.resumeUploadErrorMessage = 'File type should be .doc or .pdf or .docx or .txt';
          this.jdDataLoading = false;
        }
      })
    }
    }

  private validateInputFile() {
    const validFileExtensions = ['doc', 'docx', 'pdf', 'txt', 'odt'];
    const uploadedFileExtension = this.uploadedFile.name.split('.').pop();
    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
        this.jdDataLoading = false;

    }

    // Verify file size (File size cannot exceed 5 MB)
    if (this.uploadedFile.size > 5242880) {
      this.fileSizeLimitExceeded = true;
        this.jdDataLoading = false;

    }
  }

    openSimilarCandidateFilters(type: string) {
      this.personsearchservice.passsimilarcandidatesdata( {data: this.similarobj, calledfrom: type });
      // const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size',centered: true, backdrop: 'static', keyboard: false });
      // modalRef.result.then((res) => {
      //   if(res.action == 'submit') {
      //     this.personsearchservice.passsimilarcandidatesdata(res);
      //     this.modalService.dismissAll();
      //     this.localStorageService.setItem('similar-candidates-additional-filters', JSON.stringify(res));
      //     this.router.navigate(['/person/search/listing'], { queryParams: { type: res.calledfrom } });
      //   }
      // });
    //  this.router.navigate(['/person/search/listing'], { queryParams: { type: type } });

      const modalRef = this.modalService.open(
        AiModalScComponent,
        { size: 'xl', windowClass: 'genAimodal',centered: true, backdrop: 'static', keyboard: false }
      );
      const modalInstance: AiModalScComponent = modalRef.componentInstance;
      modalInstance.similarCandidateData = { data: this.similarobj, calledfrom: type } as unknown as SCPassData;
      this.localStorageService.setItem('similar-candidates-additional-filters', JSON.stringify(this.similarobj));

      // const modalResult$ = from(modalRef.result);
      // modalResult$.subscribe((res: SCPassData) => {
      // });
    }

    resetFormFields() {
      this.uploadedFilename = null;
      this.disableSimilarBtn = true;
      this.resumeUploadErrorMessage= '';
      this.jdDataLoading = false;
      this.specialCharaterError = false;
      this.fileSizeLimitExceeded = false;
      this.incorrectFileFormat = false
    }
}
